/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Internalsandbox2Inputs */

const id_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox Internal`)
};

const ms_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox Dalaman`)
};

const da_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern Sandbox`)
};

const de_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Sandbox`)
};

const en_us2_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Sandbox`)
};

const es_es2_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox interno`)
};

const es_mx2_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox interno`)
};

const fil_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal na Sandbox`)
};

const fr_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox interne`)
};

const it_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox interno`)
};

const hu_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belső sandbox`)
};

const nl_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Sandbox`)
};

const no_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern sandbox`)
};

const pl_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewnętrzny Sandbox`)
};

const pt_br2_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Sandbox`)
};

const pt_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox interno`)
};

const ro_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox intern`)
};

const fi_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisäinen hiekkalaatikko`)
};

const sv_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern sandlåda`)
};

const vi_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nội bộ`)
};

const tr_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dahili Sandbox`)
};

const cs_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interní Sandbox`)
};

const bg_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вътрешен Sandbox`)
};

const ru_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренняя песочница`)
};

const uk_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутрішній Sandbox`)
};

const ar_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox داخلي`)
};

const hi_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आंतरिक सैंडबॉक्स`)
};

const th_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์ภายใน`)
};

const ja_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内部サンドボックス`)
};

const zh_cn2_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Sandbox`)
};

const zh_hant1_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Sandbox`)
};

const ko_components_sandboxshell_internalsandbox2 = /** @type {(inputs: Components_Sandboxshell_Internalsandbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Sandbox`)
};

/**
* | output |
* | --- |
* | "Internal Sandbox" |
*
* @param {Components_Sandboxshell_Internalsandbox2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_internalsandbox2 = /** @type {((inputs?: Components_Sandboxshell_Internalsandbox2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Internalsandbox2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "ms") return ms_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "da") return da_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "de") return de_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "fil") return fil_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "fr") return fr_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "it") return it_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "hu") return hu_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "nl") return nl_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "no") return no_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "pl") return pl_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "pt") return pt_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "ro") return ro_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "fi") return fi_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "sv") return sv_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "vi") return vi_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "tr") return tr_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "cs") return cs_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "bg") return bg_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "ru") return ru_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "uk") return uk_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "ar") return ar_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "hi") return hi_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "th") return th_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "ja") return ja_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_internalsandbox2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_internalsandbox2(inputs)
	return ko_components_sandboxshell_internalsandbox2(inputs)
});
export { components_sandboxshell_internalsandbox2 as "components.sandboxShell.internalSandbox" }